/**
 * @generated SignedSource<<a990f6bc480028aa6d8a4f573e07b1ec>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FacilityType = "DINING" | "GOLF_COURSE" | "RACQUET" | "SIMULATOR";
export type MoveBookingScreenQuery$variables = {
  bookingId: string;
  date: string;
};
export type MoveBookingScreenQuery$data = {
  readonly node: {
    readonly __typename?: string;
    readonly id?: string;
    readonly startSlot?: {
      readonly agenda: {
        readonly date: string;
        readonly facility: {
          readonly type: FacilityType;
        };
      };
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
  readonly session: {
    readonly currentClientProfile: {
      readonly member: {
        readonly membershipType: {
          readonly id: string;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"TeeSheet_HeaderData">;
  } | null | undefined;
};
export type MoveBookingScreenQuery = {
  response: MoveBookingScreenQuery$data;
  variables: MoveBookingScreenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "date"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bookingId"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "date",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "supportsPrivate",
  "storageKey": null
},
v8 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isFacilityBookable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsVisible",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "areOtherBookingsJoinable",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "canBookOnBusySlot",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v11 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": [
      "WAITLIST"
    ]
  }
],
v12 = [
  (v4/*: any*/),
  (v1/*: any*/)
],
v13 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": (v12/*: any*/),
  "storageKey": null
},
v14 = {
  "kind": "InlineFragment",
  "selections": (v2/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MoveBookingScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "TeeSheet_HeaderData"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v2/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v4/*: any*/),
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agenda",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MoveBookingScreenQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Session",
        "kind": "LinkedField",
        "name": "session",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "currentClientProfile",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "member",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Club",
                    "kind": "LinkedField",
                    "name": "club",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FacilityConnection",
                        "kind": "LinkedField",
                        "name": "facilities",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FacilityEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Facility",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Club",
                                    "kind": "LinkedField",
                                    "name": "club",
                                    "plural": false,
                                    "selections": [
                                      (v1/*: any*/),
                                      (v7/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "supportsPublic",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "calendarStartDay",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PublicBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "publicBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PrivateBookingPermissionSet",
                                    "kind": "LinkedField",
                                    "name": "privateBookingPermissionSet",
                                    "plural": false,
                                    "selections": (v8/*: any*/),
                                    "storageKey": null
                                  },
                                  (v9/*: any*/),
                                  (v10/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Department",
                                    "kind": "LinkedField",
                                    "name": "department",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v1/*: any*/),
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "displayNameOrFacilityName",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseConnection",
                                    "kind": "LinkedField",
                                    "name": "courses",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Course",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v1/*: any*/),
                                              (v10/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "maxMultipleBookings",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "multipleBookingsEnabled",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "publicBookingWindowDays",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "memberBookingWindowDays",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Variable",
                                        "name": "dateGte",
                                        "variableName": "date"
                                      },
                                      {
                                        "kind": "Variable",
                                        "name": "dateLte",
                                        "variableName": "date"
                                      }
                                    ],
                                    "concreteType": "AgendaConnection",
                                    "kind": "LinkedField",
                                    "name": "agendas",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "AgendaEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Agenda",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "QueueSlot",
                                                "kind": "LinkedField",
                                                "name": "queueSlot",
                                                "plural": false,
                                                "selections": (v2/*: any*/),
                                                "storageKey": null
                                              },
                                              {
                                                "alias": "waitlistRestrictions",
                                                "args": (v11/*: any*/),
                                                "concreteType": "AgendaBookingRulesConnection",
                                                "kind": "LinkedField",
                                                "name": "bookingRules",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "AgendaBookingRulesEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "liftAt",
                                                        "storageKey": null
                                                      },
                                                      (v13/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "FacilityStartEndTime",
                                    "kind": "LinkedField",
                                    "name": "startEndTime",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "startTime",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "endTime",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "bookingType",
                                        "value": "STANDARD"
                                      }
                                    ],
                                    "concreteType": "GroupSize",
                                    "kind": "LinkedField",
                                    "name": "minMaxGroupSize",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "min",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "max",
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "minMaxGroupSize(bookingType:\"STANDARD\")"
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "CourseLayoutConnection",
                                    "kind": "LinkedField",
                                    "name": "courseLayouts",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "CourseLayoutEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "CourseLayout",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "enabled",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "holeCount",
                                                "storageKey": null
                                              },
                                              (v1/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": "waitlistRestrictions",
                                    "args": (v11/*: any*/),
                                    "concreteType": "BookingRuleConnection",
                                    "kind": "LinkedField",
                                    "name": "bookingRules",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "BookingRuleEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          (v13/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": "bookingRules(type:[\"WAITLIST\"])"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/),
                      (v10/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Image",
                        "kind": "LinkedField",
                        "name": "logoImage",
                        "plural": false,
                        "selections": [
                          {
                            "alias": "publicId",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "renderingKey",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v7/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v14/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": (v2/*: any*/),
                    "type": "Customer",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v2/*: any*/),
                    "type": "Member",
                    "abstractKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "membershipType",
                    "plural": false,
                    "selections": (v12/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientClass",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v1/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "email",
                    "storageKey": null
                  }
                ],
                "type": "MemberUser",
                "abstractKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v1/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agenda",
                    "kind": "LinkedField",
                    "name": "agenda",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Facility",
                        "kind": "LinkedField",
                        "name": "facility",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v1/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Booking",
            "abstractKey": "__isBooking"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1e7f049ba78c5594743037c18a6860f6",
    "id": null,
    "metadata": {},
    "name": "MoveBookingScreenQuery",
    "operationKind": "query",
    "text": "query MoveBookingScreenQuery(\n  $bookingId: ID!\n  $date: Date!\n) {\n  session {\n    ...TeeSheet_HeaderData\n    currentClientProfile {\n      __typename\n      member {\n        __typename\n        membershipType {\n          __typename\n          id\n        }\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  node(id: $bookingId) {\n    __typename\n    ... on Booking {\n      __isBooking: __typename\n      __typename\n      id\n      startSlot {\n        __typename\n        id\n        agenda {\n          date\n          facility {\n            type\n            id\n          }\n          id\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment AgendaDateSelectorControlFragment_facility on Facility {\n  id\n  publicBookingWindowDays\n  memberBookingWindowDays\n  club {\n    supportsPrivate\n    ...useGetClubStartOfWeekNumberPatron_club\n    id\n  }\n}\n\nfragment FacilityLogoFragment_club on Club {\n  logoImage {\n    publicId: renderingKey\n  }\n}\n\nfragment ScheduleSwitcher_session on Session {\n  ...useGetScheduleSwitcherOptionsFragment_session\n}\n\nfragment TeeSheetAgendaHeaderDesktopNewFragment_club on Club {\n  name\n  ...FacilityLogoFragment_club\n}\n\nfragment TeeSheetAgendaHeaderMobileNewFragment_club on Club {\n  name\n  ...FacilityLogoFragment_club\n  supportsPrivate\n  logoImage {\n    publicId: renderingKey\n  }\n  facilities {\n    edges {\n      node {\n        id\n        name\n        displayNameOrFacilityName\n        slug\n      }\n    }\n  }\n}\n\nfragment TeeSheetAgendaSidebarFragment_facility on Facility {\n  id\n  club {\n    supportsPrivate\n    id\n  }\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...TeeSheetMultipleBookingToggleFragment_Facility\n  ...TeeSheetCourseSelectorControlFragment_facility\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n  ...TeeSheetHoleCountSelectorControl_facility\n}\n\nfragment TeeSheetAgendaSidebar_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment TeeSheetBasedFiltersModalFragment_facility on Facility {\n  id\n  club {\n    supportsPrivate\n    id\n  }\n  ...useFacilityStartEndTime_facility\n  ...useFacilityGroupSize_facility\n  ...TeeSheetCourseSelectorControlFragment_facility\n  ...TeeSheetMultipleBookingToggleFragment_Facility\n  ...AgendaDateSelectorControlFragment_facility\n  ...facilityToScheduleOption_facility\n  ...TeeSheetHoleCountSelectorControl_facility\n}\n\nfragment TeeSheetBasedFiltersModal_session on Session {\n  ...ScheduleSwitcher_session\n}\n\nfragment TeeSheetCourseSelectorControlFragment_facility on Facility {\n  id\n  name\n  slug\n  multipleBookingsEnabled\n  courses {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n\nfragment TeeSheetHoleCountSelectorControl_facility on Facility {\n  id\n  courseLayouts {\n    edges {\n      node {\n        enabled\n        holeCount\n        id\n      }\n    }\n  }\n}\n\nfragment TeeSheetMultipleBookingToggleFragment_Facility on Facility {\n  multipleBookingsEnabled\n}\n\nfragment TeeSheet_HeaderData on Session {\n  ...TeeSheetAgendaSidebar_session\n  ...TeeSheetBasedFiltersModal_session\n  user {\n    __typename\n    ... on MemberUser {\n      id\n      email\n    }\n    id\n  }\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      ... on Customer {\n        id\n      }\n      ... on Member {\n        id\n      }\n      membershipType {\n        __typename\n        id\n      }\n      clientClass\n      club {\n        id\n        ...TeeSheetAgendaHeaderDesktopNewFragment_club\n        ...TeeSheetAgendaHeaderMobileNewFragment_club\n        ...useResetTeeSheetFilters_club\n        facilities {\n          edges {\n            node {\n              id\n              name\n              slug\n              maxMultipleBookings\n              multipleBookingsEnabled\n              ...useGetBookingWindowDaysByFacilityId\n              ...getFacilityMemberPermissions_facility\n              ...WaitlistModalFragment_Facility\n              ...TeeSheetAgendaSidebarFragment_facility\n              ...TeeSheetBasedFiltersModalFragment_facility\n              ...AgendaDateSelectorControlFragment_facility\n              courses {\n                edges {\n                  node {\n                    name\n                    id\n                  }\n                }\n              }\n              department {\n                type\n                id\n              }\n              waitlistRestrictions: bookingRules(type: [WAITLIST]) {\n                edges {\n                  node {\n                    __typename\n                    id\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment WaitlistModalFragment_Facility on Facility {\n  agendas(dateGte: $date, dateLte: $date) {\n    edges {\n      node {\n        queueSlot {\n          id\n        }\n        waitlistRestrictions: bookingRules(type: [WAITLIST]) {\n          edges {\n            liftAt\n            node {\n              __typename\n              id\n            }\n          }\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment departmentToScheduleOption_department on Department {\n  type\n  id\n  slug\n  name\n}\n\nfragment facilityToScheduleOption_facility on Facility {\n  id\n  slug\n  name\n  type\n  department {\n    type\n    id\n  }\n}\n\nfragment getFacilityMemberPermissions_facility on Facility {\n  club {\n    id\n    supportsPrivate\n    supportsPublic\n  }\n  publicBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n  privateBookingPermissionSet {\n    id\n    isFacilityVisible\n    isFacilityBookable\n    areOtherBookingsVisible\n    areOtherBookingsJoinable\n    canBookOnBusySlot\n  }\n}\n\nfragment useFacilityGroupSize_facility on Facility {\n  minMaxGroupSize(bookingType: STANDARD) {\n    min\n    max\n  }\n}\n\nfragment useFacilityStartEndTime_facility on Facility {\n  startEndTime {\n    startTime\n    endTime\n  }\n}\n\nfragment useGetBookingWindowDaysByFacilityId on Facility {\n  id\n  publicBookingWindowDays\n  memberBookingWindowDays\n  club {\n    supportsPrivate\n    id\n  }\n}\n\nfragment useGetClubStartOfWeekNumberPatron_club on Club {\n  calendarStartDay\n}\n\nfragment useGetScheduleSwitcherOptionsFragment_session on Session {\n  currentClientProfile {\n    __typename\n    member {\n      __typename\n      club {\n        facilities {\n          edges {\n            node {\n              type\n              id\n              ...getFacilityMemberPermissions_facility\n              ...facilityToScheduleOption_facility\n              department {\n                id\n                type\n                ...departmentToScheduleOption_department\n              }\n            }\n          }\n        }\n        id\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment useResetTeeSheetFilters_club on Club {\n  id\n  facilities {\n    edges {\n      node {\n        id\n        slug\n        courses {\n          edges {\n            node {\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d3ec66b0f56a9a6231845f3eb8f6b91f";

export default node;
